<template>
        <card>
           <template slot="header">
              <h3 class="card-title">Adjustment Form</h3>
           </template>
           <nav class="row">
              <ol class="breadcrumb arr-right bg-breadcrum">
                 <li class="breadcrumb-item">
                    <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                 </li>
                 <li class="breadcrumb-item">
                    <router-link to="/hr/scheduleadjustment">Schedule Adjustment</router-link>
                 </li>
                 <li class="breadcrumb-item active">Adjustment Form</li>
              </ol>
           </nav>
           <hr style="margin-top:-10px"/>
           <form @submit.prevent="formSubmit">
              <div class="row">
                 <div class="col-md-12">
                    <label>Employee Name</label>
                    <select class="form-control" v-model="employee_id" v-on:change="selected_employee"  v-bind:class="{ 'is-invalid': error_handler && error_handler.employee_id }">
                       <option value="">-- Select One --</option>
                       <option v-for="emp in employees" v-bind:value="emp.id">{{emp.full_name | capitalize}}</option>
                    </select>
                    <span v-if="error_handler.employee_id" class="invalid-feedback">{{ error_handler.employee_id[0] }}</span>
                 </div>
              </div>
              <br/>  
              <font color="#4285f4" class="title-section"><i class="fa fa-wpforms"></i> Employee Adjustment Request</font>   
              <div class="border-box-adjustment">
                 <div class="row">
                    <div class="col-md-6">
                       <div class="form-group">
                          <label>Date Filled:</label>
                          <input type="date" class="form-control" v-model="date_filled" v-bind:class="{ 'is-invalid': error_handler && error_handler.date_filled }">
                          <span v-if="error_handler.date_filled" class="invalid-feedback">{{ error_handler.date_filled[0] }}</span>    
                       </div>
                       <div class="form-group">
                          <label>Date Of Request:</label>
                          <input type="date" class="form-control" v-model="date_of_request" v-bind:class="{ 'is-invalid': error_handler && error_handler.date_of_request }">
                          <span v-if="error_handler.date_of_request" class="invalid-feedback">{{ error_handler.date_of_request[0] }}</span>    
                       </div>
                       <div class="row">
                          <div class="col-md-6">
                             <div class="form-group">
                                <label>Current Shift:</label>
                                <input type="text" class="form-control" v-model="sched_item.time"  v-bind:class="{ 'is-invalid': error_handler && error_handler.current_shift }" disabled>
                                <span v-if="error_handler.current_shift" class="invalid-feedback">{{ error_handler.current_shift[0] }}</span> 
                             </div>
                          </div>
                          <div class="col-md-6">
                             <div class="form-group">
                                <label>Requested Shift:</label>
                                <span v-if="error_handler.requested_shift" class="invalid-feedback">{{ error_handler.requested_shift[0] }}</span>    
                                <select class="form-control" v-model="requested_shift" v-bind:class="{ 'is-invalid': error_handler && error_handler.requested_shift }">
                                   <option value="">--Select One--</option>
                                   <option value="9PM - 6AM">9PM - 6AM</option>
                                   <option value="10PM - 7AM">10PM - 7AM</option>
                                   <option value="11PM - 8AM">11PM - 8AM</option>
                                   <option value="12PM - 9AM">12PM - 9AM</option>
                                   <option value="1PM - 10AM">1PM - 10AM</option>
                                   <option value="2PM - 11AM">2PM - 11AM</option>
                                   <option value="6AM - 3PM">6AM - 3PM</option>
                                   <option value="7AM - 4PM">7AM - 4PM</option>
                                   <option value="8AM - 5PM">8AM - 6PM</option>
                                   <option value="9AM - 7PM">9AM - 7PM</option>
                                   <option value="10AM - 8PM">10AM - 8PM</option>
                                   <option value="3PM - 12PM">3PM - 12PM</option>
                                   <option value="4PM - 1AM">4PM - 1AM</option>
                                </select>
                                <span v-if="error_handler.requested_shift" class="invalid-feedback">{{ error_handler.requested_shift[0] }}</span> 
                             </div>
                          </div>
                       </div>
                    </div>
                    <div class="col-md-6">
                       <div class="form-group">
                          <label>Reason for Change</label>
                          <textarea rows="8"class="form-control" v-model="reason_for_change"  v-bind:class="{ 'is-invalid': error_handler && error_handler.reason_for_change }"></textarea>
                          <span v-if="error_handler.reason_for_change" class="invalid-feedback">{{ error_handler.reason_for_change[0] }}</span>       
                       </div>
                    </div>
                 </div>
              </div>
              <br/> <font color="#4285f4" class="title-section"><i class="fa fa-wpforms"></i> Approval Status</font>
              <div class="border-box-adjustment">
                 <div class="row">
                    <div class="col-md-4">
                       <label>Supervisor Approval</label>
                       <select class="form-control" v-model="tl_status" v-bind:class="{ 'is-invalid': error_handler && error_handler.tl_status }">
                          <option value="">--Select One--</option>
                          <option value="pending">pending</option>
                          <option value="approved">approved</option>
                          <option value="rejected">rejected</option>
                       </select>
                       <span v-if="error_handler.tl_status" class="invalid-feedback">{{ error_handler.tl_status[0] }}</span>     
                    </div>
                    <div class="col-md-4">
                       <label>Departamental Head Approval</label>
                       <select class="form-control" v-model="asm_status" v-bind:class="{ 'is-invalid': error_handler && error_handler.asm_status }">
                          <option value="">--Select One--</option>
                          <option value="pending">pending</option>
                          <option value="approved">approved</option>
                          <option value="rejected">rejected</option>
                       </select>
                       <span v-if="error_handler.asm_status" class="invalid-feedback">{{ error_handler.asm_status[0] }}</span> 
                    </div>
                    <div class="col-md-4">
                       <label>HR Department Approval</label>
                       <select class="form-control" v-model="hr_status" v-bind:class="{ 'is-invalid': error_handler && error_handler.hr_status }">
                          <option value="">--Select One--</option>
                          <option value="pending">pending</option>
                          <option value="approved">approved</option>
                          <option value="rejected">rejected</option>
                       </select>
                       <span v-if="error_handler.hr_status" class="invalid-feedback">{{ error_handler.hr_status[0] }}</span> 
                    </div>
                 </div>
                 <hr/>
                 <div class="row">
                    <div class="col-md-4">
                       <label>Supervisor Date Approval</label>
                       <div class="form-group" >
                          <input type="date"  class="form-control" v-model="tl_date_approved" v-bind:class="{ 'is-invalid': error_handler && error_handler.tl_date_approved }">
                          <span v-if="error_handler.tl_date_approved" class="invalid-feedback">{{ error_handler.tl_date_approved[0] }}</span> 
                       </div>
                    </div>
                    <div class="col-md-4">
                       <label>Departamental Head Date Approval</label>
                       <div class="form-group">
                          <input type="date"   class="form-control" v-model="asm_date_approved" v-bind:class="{ 'is-invalid': error_handler && error_handler.asm_date_approved }">
                          <span v-if="error_handler.asm_date_approved" class="invalid-feedback">{{ error_handler.asm_date_approved[0] }}</span> 
                       </div>
                    </div>
                    <div class="col-md-4">
                       <label>HR Date Approval</label>
                       <div class="form-group">
                          <input type="date"  class="form-control" v-model="hr_date_approved" v-bind:class="{ 'is-invalid': error_handler && error_handler.hr_date_approved }">
                          <span v-if="error_handler.hr_date_approved" class="invalid-feedback">{{ error_handler.hr_date_approved[0] }}</span> 
                       </div>
                    </div>
                 </div>
              </div>
              <div class="form-group">
                 <div class="float-right">  
                    <br/> <button class="btn btn-info"><i class="fa fa-location-arrow"></i>&nbsp;Submit Request</button> <br/><br/>
                 </div>
              </div>
              <br/> <br/>   
           </form>
        </card>
     </template>
    <script>
    /* eslint-disable */
    import Card from 'src/components/UIComponents/Cards/Card.vue'
    export default {  
    components: {
      Card,
    },
    
    data() {
      return {
         //input
         employee_id:'',
         date_filled:'',
         date_of_request:'',
         current_shift:'',
         requested_shift:'',
         reason_for_change:'',
         tl_status:'',
         asm_status:'',
         hr_status:'',
         tl_date_approved:'',
         asm_date_approved:'',
         hr_date_approved:'',
         employees:[],
         // Errors handler
         error_handler:[],
       
         sched_item:''
      }
    },
    
    mounted: function() {
        this.get_employees()
        this.selected_employee()
    },
    
    methods: {
      get_employees(){
        axios.get('api/employeeworkshift')
                .then(response => {  this.employees = response.data; })  
                .catch(error => {  console.log(error.response)  });
        },
     
      
       selected_employee(){   
         let data = ''

         if(this.employee_id == 1){
            data = 1 
         }else{
            axios.get('api/getcurrentshift/get/' + this.employee_id)  
              .then(response => { this.sched_item = response.data; console.log(this.sched_item)})
              .catch(error => {  console.log(error) });
         }

         
            console.log(data)
        },


           
      formSubmit(e) {
         e.preventDefault();
         this.$swal({
               title: 'Are you sure?',
               text: 'Do you want to save',
               type: 'warning',
               showCancelButton: true,
               showCloseButton: false,
            })
            .then((isConfirm) => {
               if (isConfirm === true) {
                    axios.post('api/scheduleadjustment/add', {     
                       // ADJUSTMENT 
                        employee_id:this.employee_id,
                        date_filled:this.date_filled,
                        date_of_request:this.date_of_request,
                        current_shift:this.sched_item.time,
                        requested_shift:this.requested_shift,
                        reason_for_change:this.reason_for_change,
                        tl_status:this.tl_status,
                        asm_status:this. asm_status,
                        hr_status:this.hr_status,
                        tl_date_approved:this.tl_date_approved,
                        asm_date_approved:this.asm_date_approved,
                        hr_date_approved:this.hr_date_approved

                     })
                     .then(resp => {
                              this.$swal('Save', 'You successfully save this file', 'success')
                              this.$router.push({
                                name: 'schedule-adjustment'
                            })  
                     })                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
                     .catch(error => {
                        if (error.response.status == 422){
                                this.error_handler = error.response.data.errors 
                        }
                        console.log('response => ', error.response);
                     });
               }
            });
      },     
    },
    computed: {
       
    },
    
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        //return value.charAt(0).toUpperCase() + value.slice(1); -> capitalize first 
        return value.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }); // -> capitalize each first words
       }
     },
  
    }
    </script>
    <style>
        .fa-update{
            color:#07b22c;
            font-size:19px;
        }
        .bg-breadcrum{
            background:#fff;
            }
  
            .m-right{
                margin:0px !important;
                padding-right: 0px!important;
            }
            .bg-breadcrum{
                background:#fff;
             }
             .border-box-adjustment{
                 border: 1px dashed #666;
                 width: 100%;
                 padding: 20px;
             }
             .title-section{
                  font-size: 18px;
             }
    </style>
    
    
    


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/todo-adjustment-form.vue